import KSI from '@sailor/ksi-machpro';
import { reduceStrArrToMap } from '.';
import { logan, reportMetrics } from '../pages/order/order_confirm_golden/monitor';
import Constant from './constant';
import { buildUrl } from './router';

export const PAYMENT_PARAMS = reduceStrArrToMap(['bizRenderData', 'preDecisionRequestData', 'preDecisionResponseData', 'preDecisionSceneCode', 'bizExtraData', 'isNewPredecisionProcess']);
export const getEnableAPIMergedCashier = (res) => !!res?.extra?.finance_promo_1017;

// 缓存 KSI 开关值，避免重复调用 KSI 桥
let cachedIsKSIAvailable: boolean | undefined;

/**
 * 获取支付 KSI 方案是否可用
 * 通过 Horn 配置判断是否开通支付 KSI 方案，失败时默认返回 false
 */
export const isPaymentKSIAvailable = (): boolean => {
  // 已缓存则直接返回
  if (cachedIsKSIAvailable !== undefined) {
    return cachedIsKSIAvailable;
  }

  try {
    const hornParams = KSI?.getHornConfigSync?.({ hornKey: 'international_precashier' });
    cachedIsKSIAvailable = !!hornParams?.data?.enable_ksi;
  } catch {
    cachedIsKSIAvailable = false;
  }
  return cachedIsKSIAvailable;
};

/**
 * 支付组件预热
 * @param result
 */
export const preloadPayment = (result) => {
  const merchantId = result?.merchantId || '';
  const enableAPIMergedCashier = getEnableAPIMergedCashier(result);
  let payPrice = result?.orderInfo?.payPrice;

  if (enableAPIMergedCashier) {
    payPrice = result?.payPriceWithoutFinBen;
  }

  const PaymentDataFromBusinessSideSuccessRate = result?.finRes ? 1 : 0;

  reportMetrics({
    PaymentDataFromBusinessSideSuccessRate
  }, {
    status: PaymentDataFromBusinessSideSuccessRate,
    enableAPIMergedCashier: enableAPIMergedCashier ? '1' : '0',
    useKSIBridge: isPaymentKSIAvailable() ? '1' : '0'
  });

  const params = {
    bizType: 'sailor_pre_cashier',
    bizData: {
      merchantId: `${merchantId}`,
      restrictPayMethods: [],
      forexBizIdentity: result?.forexBizIdentity,
      tradeAmount: {
        cent: payPrice?.amount || 0,
        currencyCode: payPrice?.currency || '',
        currencySymbol: payPrice?.currencySign ?? ''
      },
      [PAYMENT_PARAMS.bizExtraData]: {
        [PAYMENT_PARAMS.isNewPredecisionProcess]: enableAPIMergedCashier
      }
    },
    [PAYMENT_PARAMS.bizRenderData]: result?.finRes ?? ''
  };

  if (isPaymentKSIAvailable()) {
    KSI?.preloadPayComponentSync?.(params);
  } else {
    const PayService = Mach.requireModule('PayService');
    PayService?.preloadComponent?.(params);
  }
};

/**
 * 获取参数
 * @returns
 *  {
        nbParams?: any;
        installedApps?: any;
    }
 */
export const getPreDecisionParams = () => {
  let preDecisionParams = {};
  const startTime = Date.now();

  if (isPaymentKSIAvailable()) {
    // KSI逻辑
    preDecisionParams = KSI?.getPayDecisionParamsSync?.();
  } else {
    // 旧逻辑，兼容老版本
    const PayService = Mach.requireModule('PayService');
    preDecisionParams = PayService?.getPreDecisionParams?.() ?? {};
  }

  const duration = Date.now() - startTime;
  let PaymentGetPreDecisionParamsSuccessRate;

  logan({
    end: 'payment',
    step: 'preDecisionParams',
    data: preDecisionParams,
    duration,
    useKSIBridge: isPaymentKSIAvailable() ? '1' : '0'
  });

  try {
    PaymentGetPreDecisionParamsSuccessRate = Object.keys(preDecisionParams)?.length > 0 ? 1 : 0;
  } catch (error) {
    PaymentGetPreDecisionParamsSuccessRate = 0;
  }

  reportMetrics({
    PaymentGetPreDecisionParamsSuccessRate: duration
  }, {
    status: PaymentGetPreDecisionParamsSuccessRate,
    useKSIBridge: isPaymentKSIAvailable() ? '1' : '0',
    duration
  });

  return preDecisionParams;
};

export const getDefaultPreDecisionParams = () => ({
  ...getPreDecisionParams(),
  payTypeCustomizedScene: []
});

export interface IPixSchemeParams {
  payToken: string;
  tradeNumber: string;
  merchantId: string;
  forexBizIdentity: number;
  payMethod: string;
  callbackUrl?: string;
}

export const getPaySchemeURL = (params: IPixSchemeParams) => {
  const {
    payToken = '',
    tradeNumber = '',
    merchantId = '',
    forexBizIdentity = '',
    payMethod = '',
    callbackUrl = '',
  } = params || {};
  const isPixPay = payMethod?.indexOf?.('Pix') !== -1;
  const scheme = isPixPay ? Constant.PIX_PAY_SCHEME : Constant.SCHEME_PAY;
  const schemeParams = {
    pay_token: payToken,
    trade_number: tradeNumber,
    forex_biz_identity: forexBizIdentity,
    merchant_id: merchantId,
    callback_url: callbackUrl,
  };
  return buildUrl(scheme, schemeParams);
};
